<template>
    <div class="copy">
        <span class="copy__text" ref="copyText">{{ copyData }}</span>
        <v-btn color="primary" @click="copyString" icon outlined>
            <v-icon color="primary" size="20">file_copy</v-icon>
        </v-btn>
        <span class="copy__success" ref="copySuccess">Скопировано</span>
    </div>
</template>

<script>
export default {
    name: "Copy",
    data: () => ({}),
    props: {
        copyData: {
            type: String
        }
    },
    methods: {
        copyString() {
            const doc = document;
            const element = this.$refs["copyText"];
            if (doc.body.createTextRange) {
                const range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
                document.execCommand("copy");
            } else if (window.getSelection) {
                const selection = window.getSelection();
                const range = document.createRange();
                range.selectNodeContents(element);
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand("copy");
            }
            window.getSelection().removeAllRanges();
            const tipElement = this.$refs["copySuccess"];
            tipElement.classList.add("copy__success--show");
            setTimeout(() => {
                tipElement.classList.remove("copy__success--show");
            }, 2000);
        }
    }
};
</script>

<style lang="scss" scoped>
.copy {
    position: relative;
    &__text {
        height: 0px;
        width: 0px;
        font-size: 0px;
        overflow: hidden;
    }
    &__success {
        font-size: 11px;
        padding-left: 10px;
        font-weight: 700;
        color: #404ce6;
        z-index: 1;
        opacity: 0;
        transition: opacity 0.3s ease;
        position: absolute;
        top: -16px;
        left: -28px;

        &--show {
            opacity: 1;
        }
    }
}
</style>
